import React from 'react';
import { HomePage } from '../components/pages';

export default function Home() {
  return <HomePage />;
}
